module.exports = __webpack_public_path__ + "static/media/img-file.a2c41278.png";